"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowActionSchema = exports.cancelSignatureRequestedWorkflowActionSchema = exports.signedProposalSentWorkflowActionSchema = exports.signatureSubmittedWorkflowActionSchema = exports.signatureRequestedWorkflowActionSchema = exports.proposalSubmittedWorkflowActionSchema = exports.proposalUpdateRequestedWorkflowActionSchema = exports.proposalRequestedWorkflowActionSchema = exports.closedWorkflowActionSchema = void 0;
const zod_1 = require("zod");
const longField_schema_1 = require("../../common/schemas/longField.schema");
const selectedItemWithName_schema_1 = require("../../common/schemas/selectedItemWithName.schema");
const workflowAction_schema_1 = require("../../common/schemas/workflowAction.schema");
const Purpose_1 = require("../types/Purpose");
const ReceivedVia_1 = require("../types/ReceivedVia");
const Response_1 = require("../types/Response");
const amountWithCurrency_schema_1 = require("./common/amountWithCurrency.schema");
exports.closedWorkflowActionSchema = workflowAction_schema_1.baseClosedWorkflowAction
    .extend({
    action: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Response_1.Response, [
        Response_1.Response.Approved,
        Response_1.Response.ReviewedAsNoted,
        Response_1.Response.NoExceptions,
        Response_1.Response.Rejected,
        Response_1.Response.ReviseAndResubmit,
        Response_1.Response.Reviewed,
    ]),
})
    .strict();
exports.proposalRequestedWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [Purpose_1.Purpose.ForReview]),
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema,
    cc: workflowAction_schema_1.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.proposalUpdateRequestedWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [Purpose_1.Purpose.ForReview]),
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema,
    cc: workflowAction_schema_1.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.proposalSubmittedWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForInformationOnly,
    ]),
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema.array().nonempty(),
    cc: workflowAction_schema_1.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
    proposedTotalAmount: amountWithCurrency_schema_1.amountWithCurrencySchema.optional(),
    proposedTotalDays: zod_1.z.number().nonnegative().int().optional(),
    contractorSenderNumber: zod_1.z.string().optional(),
    receivedVia: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(ReceivedVia_1.ReceivedVia).optional(),
    receivedDate: zod_1.z.string().optional(),
})
    .strict();
exports.signatureRequestedWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .extend({
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema,
    cc: workflowAction_schema_1.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.signatureSubmittedWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .extend({
    response: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Response_1.Response, [
        Response_1.Response.Approved,
        Response_1.Response.ReviewedAsNoted,
        Response_1.Response.NoExceptions,
        Response_1.Response.NoActionTaken,
        Response_1.Response.Reviewed,
        Response_1.Response.Void,
    ]),
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema,
    cc: workflowAction_schema_1.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.signedProposalSentWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .extend({
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema.array().nonempty(),
    cc: workflowAction_schema_1.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForReview,
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForUpdatedQuote,
        Purpose_1.Purpose.NewQuote,
    ]),
})
    .strict();
exports.cancelSignatureRequestedWorkflowActionSchema = workflowAction_schema_1.baseWorkflowAction
    .omit({ files: true })
    .extend({
    from: workflowAction_schema_1.workflowParticipantSchema,
    to: workflowAction_schema_1.workflowParticipantSchema,
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.workflowActionSchema = zod_1.z.union([
    workflowAction_schema_1.receivedWorkflowActionSchema,
    workflowAction_schema_1.createdWorkflowActionSchema,
    workflowAction_schema_1.forwardedWorkflowActionSchema,
    workflowAction_schema_1.reviewResponseWorkflowActionSchema,
    workflowAction_schema_1.sentWorkflowActionSchema,
    exports.closedWorkflowActionSchema,
    workflowAction_schema_1.reopenedWorkflowActionSchema,
    exports.proposalRequestedWorkflowActionSchema,
    exports.proposalUpdateRequestedWorkflowActionSchema,
    exports.proposalSubmittedWorkflowActionSchema,
    exports.signatureRequestedWorkflowActionSchema,
    exports.signatureSubmittedWorkflowActionSchema,
    exports.signedProposalSentWorkflowActionSchema,
    exports.cancelSignatureRequestedWorkflowActionSchema,
    workflowAction_schema_1.receivedPendingWorkflowActionSchema,
]);
//# sourceMappingURL=workflowAction.schema.js.map